import { styled, type Theme } from '@ori-ui/mui';

export const getLinearGradient = (colors: string[]) =>
  `linear-gradient(to right, ${colors[0]}, ${colors[0]} 50%, ${colors[1]} 50%)`;

export const shadeElementStyles = (theme: Theme) =>
  ({
    borderRadius: '50%',
    display: 'inline-block',
    height: 7,
    margin: theme.spacing(1, 1, 1.2, 0),
    width: 7,
  }) as const;

export const ColorShadeElement = styled('div')<{ ownerState: { background: string } }>(
  ({ theme, ownerState: { background } }) => ({
    ...shadeElementStyles(theme),
    background,
  }),
);

export const ImageShadeElement = styled('img')(({ theme }) => shadeElementStyles(theme));

export const Root = styled('div')(({ theme }) => ({
  color: theme.palette.grey.A400,
  display: 'flex',
  alignItems: 'center',
}));
